import { render, staticRenderFns } from "./DayDetails.vue?vue&type=template&id=507332ce&scoped=true&"
import script from "./DayDetails.vue?vue&type=script&lang=js&"
export * from "./DayDetails.vue?vue&type=script&lang=js&"
import style0 from "./DayDetails.vue?vue&type=style&index=0&id=507332ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507332ce",
  null
  
)

export default component.exports